// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","624":"component---src-pages-page-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"9a44b0c96edc28263ac1","624":"72c72b61420de0060641","883":"27a34bfe2b289ab90608"}[chunkId] + ".js";
};